import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cdd6deec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrapper" }
const _hoisted_2 = { class: "d-flex justify-end mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_CustomerAccommodationInquiriesTable = _resolveComponent("CustomerAccommodationInquiriesTable")!
  const _component_CustomerAccommodationInquiryFormDialog = _resolveComponent("CustomerAccommodationInquiryFormDialog")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_sheet, { class: "pa-6 elevation-2" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            color: "primary",
            onClick: _ctx.openCreateModal
          }, {
            default: _withCtx(() => [
              _createTextVNode("+ Új szállásigény")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_component_CustomerAccommodationInquiriesTable, { accommodationInquiries: _ctx.accommodationInquiries }, null, 8, ["accommodationInquiries"]),
        _createVNode(_component_CustomerAccommodationInquiryFormDialog, {
          show: _ctx.showCreateDialog,
          onInquiryCreated: _ctx.onCreated,
          onCloseCreateInquiry: _ctx.closeCreateModal
        }, null, 8, ["show", "onInquiryCreated", "onCloseCreateInquiry"])
      ]),
      _: 1
    })
  ]))
}